export const SECTIONS = {
  DASHBOARD: 'Dashboard',
  DISPATCH: 'Dispatch',
  INVENTORY: 'Inventory',
  ENTITIES: 'Entities',
  TOOLS: 'Tools',
  OPERATIONS: 'Operations',
}
